// src/SearchMedia.js
import React, { useState, useEffect } from "react";
import AllMedia from './lists/AllMedia';

function SearchMedia() {
    const [medias, setMedias] = useState([]);

    useEffect(() => {
        fetch('/media/list-media')
            .then((response) => response.json())
            .then((data) => setMedias(data))
            .catch((error) => console.error("erreur technique"))
    }, [])


    const [recherche, setRecherche] = useState("");
    const filtreRecherche = medias.filter(media => {
        const nomComplet = `${media.nom}`.toLowerCase();
        return nomComplet.includes(recherche.toLowerCase())
    })

    const handleRecherche = (e) => {
        setRecherche(e.target.value);
    }


    return (
        <section>
            <div className="container_news favs">
                <div>
                    <h2>Rechercher</h2>
                    <input type="text" placeholder="Tapez le nom du contact"
                        value={recherche}
                        onChange={handleRecherche} />
                </div>
                <div className="liste favsList">
                    {filtreRecherche.map(media => (
                        <a
                            key={media._id}
                            className="carte"
                            href={`/video/${media._id}`}
                            style={{
                                backgroundImage: `url(${media.url})`,
                            }}
                        >
                            <h3>{media.nom}</h3>
                            <div className="overlay">
                                <img
                                    src="https://cdn0.iconfinder.com/data/icons/google-material-design-3-0/48/ic_play_circle_filled_white_48px-512.png"
                                    alt=""
                                />
                            </div>
                            <h3>{media.nom}</h3>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default SearchMedia;
